import React, { useEffect, useRef } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import i18next from 'i18next';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useReportFilterControls, useReportFilters, useReportSort } from './hooks/useReportFilters';
import { useReportData } from './hooks/useReportData';
import { useReportExport } from './hooks/useReportExport';
import ReportFilters from './components/reportFilters';
import ReportTable from './components/reportTable';

export default function RequestsTab() {
  const sort = useReportSort();
  const { handleFilterChange, handleSortChange, handleReset } = useReportFilterControls();
  const { reportResults, reportLoading, pagination, handleGenerateReport, handleReload, handleChangePage, handleChangeRowsPerPage, fetchAllReportResults, allResultsTotals } = useReportData();
  const { handleExportExcel, exportLoading } = useReportExport({ reportResults, fetchAllReportResults });
  const hasSearchedRef = useRef(false);

  useEffect(() => {
    if (hasSearchedRef.current) {
      handleReload();
    }
  }, [sort]);

  const handleGenerateReportClick = () => {
    hasSearchedRef.current = true;
    handleGenerateReport(0, pagination.rowsPerPage);
  };

  const handleResetClick = () => {
    hasSearchedRef.current = false;
    handleReset();
  };

  return (
    <Box component="form" sx={{ width: '100%' }}>
      <ReportFilters
        onFilterChange={handleFilterChange}
        onReset={handleResetClick}
      />

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 4 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGenerateReportClick}
          disabled={reportLoading}
        >
          {reportLoading ? <CircularProgress size={20} /> : i18next.t('filter-generate-report')}
        </Button>
        <Button variant="outlined" onClick={handleResetClick}>
          {i18next.t('filter-reset')}
        </Button>
      </Box>

      {reportLoading && (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>{i18next.t('report-loading')}</Typography>
        </Box>
      )}

      <ReportTable
        results={reportResults}
        loading={reportLoading}
        pagination={pagination}
        sortFields={sort}
        handleSort={handleSortChange}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        allResultsTotals={allResultsTotals}
      />

      {!reportLoading && reportResults.length > 0 && (
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<GetAppIcon />}
            onClick={handleExportExcel}
            color="secondary"
            size="large"
            disabled={exportLoading}
          >
            {exportLoading ? <CircularProgress size={20} /> : i18next.t('download-csv-report')}
          </Button>
        </Box>
      )}
    </Box>
  );
}